import { FooterConfig } from "@energylab/shared-components/constants/config/footerConfig";

export const footerConfig: FooterConfig = {
    links: ["faq", "privacy", "disclaimer", "cookyPolicy", "contact"],
    companyLogo: "https://res.cloudinary.com/energylab/image/upload/v1639663582/Ageas/ageas-v2-logo-footer.svg"
};
